import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Input from '../Input/Input';
import { ErrorMessageWrapper, SmallErrorMessage } from './Style';

interface IProps {
    id: string
    handleChange: any,
    inputLabel: string,
    data: any,
    maxLength: number,
    errorText?: string
}

const DateField:FC<IProps> = ({
    id, handleChange, inputLabel, data, maxLength, errorText
}) => {
    const { t } = useTranslation();
    const showError = !data?.isValid && (data?.errorMessage || errorText);
    const errorMessage = data?.errorMessage || errorText || (id === 'idCardIssuingDate'
        ? t('error.invalid-idDate')
        : t('error.invalid-age'));

    return (
        <>
            <Input
                data={data}
                inputLabel={inputLabel}
                type="text"
                id={id}
                handleChange={handleChange}
                autoComplete="off"
                maxLength={maxLength}
                errorText={errorMessage}
            />
            <ErrorMessageWrapper>
                {/* {!data.isValid && <SmallErrorMessage>{t('error.invalid-age')}</SmallErrorMessage>} */}
                {showError && (
                    <SmallErrorMessage>
                        {errorMessage?.startsWith('error.')
                            ? t(errorMessage)
                            : errorMessage}
                    </SmallErrorMessage>
                )}
            </ErrorMessageWrapper>
        </>
    );
};
export default DateField;
